import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  action: string;
  isBot: boolean;
  productName: string;
};

class CopOrDropEvent extends UserEvent<EventData> {
  sendToGtm() {
    gtm.pushToDataLayer({
      action: this.data.action,
      event: 'userInteraction',
      page_position: 'Cop or Drop',
      product_name: this.data.productName
    });
  }
}

export default CopOrDropEvent;
